import { ApiHelper, IApiResponse } from "../../utils/api-helper";

const url = `${process.env.REACT_APP_API_ENDPOINT}/NewDebtPlans`;
const reportUrl = `${process.env.REACT_APP_API_ENDPOINT}/Reports/NewDebtPlan`;

class NewDebtPlanService extends ApiHelper {
  constructor(_url: string) {
    super(_url);
  }

  public getNewDebtPlansActList(body: any): Promise<IApiResponse | void> {
    try {
      return super.create(body, { name: "activitylist" });
    } catch (e) {
      throw e;
    }
  }

  public getNewDebtPlansList(body: any): Promise<IApiResponse | void> {
    try {
      return super.create(body, { name: "list" });
    } catch (e) {
      throw e;
    }
  }

  public getNewDebtPlanDetail(planId: number): Promise<IApiResponse | void> {
    try {
      // this.url = mockUpEndPoint;
      return super.getById(planId);
    } catch (e) {
      throw e;
    } finally {
      // this.url = url;
    }
  }

  public addProjectToPlan(
    planId: number,
    ProjectID: number,
    queries: any
  ): Promise<IApiResponse | void> {
    try {
      this.url = `${this.url}/${planId}/project`;
      return super.update(undefined, ProjectID, undefined, queries);
    } catch (e) {
      throw e;
    } finally {
      this.url = url;
    }
  }

  public removeProjectFromPlan(
    planId: number,
    ProjectID: number
  ): Promise<IApiResponse | void> {
    try {
      this.url = `${this.url}/${planId}/project`;
      return super.delete(ProjectID);
    } catch (e) {
      throw e;
    } finally {
      this.url = url;
    }
  }

  public modifyNewDebtPlan(
    planId: number,
    body: any
  ): Promise<IApiResponse | void> {
    try {
      return super.update(body, planId);
    } catch (e) {
      throw e;
    } finally {
      this.url = url;
    }
  }
  public removeNewDebtPlan(id: number): Promise<IApiResponse | void> {
    try {
      return super.delete(id);
    } catch (e) {
      throw e;
    }
  }

  public getNewDebtPlanSummary(body: any): Promise<IApiResponse | void> {
    try {
      return super.create(body, { name: "summary" });
    } catch (e) {
      throw e;
    }
  }
  public printNewDebtPlan(id: number): Promise<IApiResponse | void> {
    this.setUrl(reportUrl);
    try {
      return super.getFileById(id);
    } catch (e) {
      throw e;
    }
  }
  public addProjectToPlanList(
    planId: number,
    queries: any
  ): Promise<IApiResponse | void> {
    try {
      this.url = `${this.url}/${planId}/project`;
      return super.updatelist(undefined, undefined, queries);
    } catch (e) {
      throw e;
    } finally {
      this.url = url;
    }
  }
}
const newDebtPlanAPI = new NewDebtPlanService(url);
export default newDebtPlanAPI;
